import client from "@/utils/client";

export const getMineral = (id: string | null) => {
  return client.get(`/common/get-mineral/${id}`);
};

export const getFeaturedCatalog = () => {
  return client.get(`/common/get-featured-catalog`);
};

export const getFeaturedMineral = () => {
  return client.post(`/admin/mineral/featured-mineral`, {});
};

export const getFollower = (data: any) => {
  return client.post(`/common/get-follower`, data);
};

export const getFollowerById = (id: any, following: any) => {
  return client.post(`/common/get-follower/${id}`, following);
};

export const createFollowerService = (data: any) => {
  return client.post(`/common/create-follow`, data);
};

export const followUnfollowService = (data: any) => {
  return client.post(`/common/follow`, data);
};

export const getFollowedBy = (data: any) => {
  return client.post(`/common/get-followedBy`, data);
};
